import React, { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from '@chakra-ui/react'

import { FileInput, Input } from '@/components/Form'

import { useCustomer } from '@/features/customers/useCustomer'
import { isNullish } from '@/utils/helper'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import { toast } from 'react-toastify'

const CustomerDetailModal = ({ modalDetail, setModalDetail }) => {
  // Redux
  const { show, isCreate, detail } = modalDetail
  const isTemporary = detail?.isTemporary

  // Hook

  const { useCreateCustomer, useUpdateCustomer, useConfirmCustomer } = useCustomer()
  const createCustomer = useCreateCustomer()
  const updateCustomer = useUpdateCustomer()

  const confirmCustomer = useConfirmCustomer()
  const methods = useForm({ defaultValues: detail })
  const dispatch = useDispatch()

  useEffect(() => {
    if (detail) {
      const { code, ...rest } = detail

      methods.reset({
        ...rest,
        code: isNullish(detail?.code) ? '' : detail?.code,
      })
    }
  }, [detail, methods])

  // Handler
  const closeModal = () => {
    setModalDetail({
      show: false,
      isCreate: true,
      detail: {},
    })
  }

  //confirm customer
  const handleConfirmCustomer = async () => {
    try {
      if (!detail?._id) {
        throw new Error('Missing Customer Id')
      }
      dispatch(showLoadingOverlay())
      await confirmCustomer.mutateAsync(detail._id)
      closeModal()
    } catch (err) {
      toast.error(err.message)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  const onSubmit = (data) => {
    if (isCreate) {
      createCustomer.mutate(data)
    } else {
      const id = detail._id

      if (!id) {
        return
      }

      updateCustomer.mutate({ id, data })
    }

    closeModal()
  }

  return (
    <Modal isOpen={show} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent maxW={'40%'}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <ModalHeader>{isCreate ? 'Add' : 'Update'} Customer</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <VStack>
                <Input name="code" label="Code" type="text" placeholder="Enter value" isRow isRequired={false} />
                <Input name="name" label={`Name`} type="text" placeholder="Enter value" isRow />
                <Input
                  name="businessRegistrationNumber"
                  label={`BR No`}
                  type="text"
                  placeholder="Enter value"
                  isRow
                  isRequired={false}
                />

                <FileInput
                  label="Damex-E"
                  name="damexEFile"
                  fileType="CUSTOMER_DAMEXE"
                  canUpload
                  isRequired={false}
                  isRow
                />
                <FileInput
                  label="Business Registration"
                  name="businessRegistrationFile"
                  fileType="CUSTOMER_BR"
                  canUpload
                  isRequired={false}
                  isRow
                />
              </VStack>
            </ModalBody>

            <ModalFooter>
              <HStack>
                {isTemporary && (
                  <Button colorScheme="blue" onClick={handleConfirmCustomer}>
                    Confirm
                  </Button>
                )}

                <Button colorScheme="green" type="submit">
                  {isCreate ? 'Add' : 'Update'}
                </Button>

                <Button colorScheme="gray" onClick={closeModal}>
                  Close
                </Button>
              </HStack>
            </ModalFooter>
          </form>
        </FormProvider>
      </ModalContent>
    </Modal>
  )
}

export default CustomerDetailModal
